import { Navigations } from './Navigations';

export default Navigations;
